import ArrowLink from "@/components/ui/arrow-link";
import { ROUTES } from "@/constants";
import { cn } from "@/lib/utils";
import { memo } from "react";

export type InlineQuoteBannerProps = {
  title?: string;
  description?: string;
  href?: string;
  linkLabel?: string;
} & React.ComponentProps<"div">;

const InlineQuoteBanner = ({
  title = "Don’t see your use case?",
  description = "Contact us to source translators for your needs.",
  className,
  href = ROUTES.getQuote,
  linkLabel = "Get  a quote",
}: InlineQuoteBannerProps) => {
  return (
    <div
      className={cn(
        "flex flex-col border border-blue rounded-xl overflow-hidden",

        className
      )}
    >
      <div className="flex flex-col p-4 lg:py-3 lg:px-6 min-w-0 flex-auto sm:flex-row sm:justify-between sm:items-center">
        <div className="grid grid-cols-1 place-content-start flex-auto min-w-0">
          <div className="text-2xl font-medium text-semantic-text-primary leading-[150%] lg:text-gray-800">
            <h4>{title}</h4>
          </div>
          {!!description && (
            <div className="text-base leading-[150%] text-[#37474f]">
              <p>{description}</p>
            </div>
          )}
        </div>
        {!!linkLabel && (
          <div className="mt-auto pt-4 sm:pt-0 sm:ml-4 sm:mt-0 flex items-center">
            <ArrowLink href={href}>{linkLabel}</ArrowLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(InlineQuoteBanner);
